// extracted by mini-css-extract-plugin
export default {"email_form":"ContactList_email_form__SGHH9"};